import React from 'react';

import { FilterField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';
import { formatNotFoundError } from '@utils';
import { FILTER_TYPE } from '@api/filters/constants';

const RelatedRiskMitigation = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add a Risk Mitigation"
    okText="ADD A RISK MITIGATION"
    onSubmit={({ entity }) => onSubmit(entity)}
  >
    <FilterField
      name="entity"
      label="Choose a risk mitigation:"
      queryVariables={{ typeId: FILTER_TYPE.RISK_MITIGATION.id }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Risk Mitigation is required' }]}
    />
  </RelatedContentModal>
);

const Item = (entity) => {
  if (entity instanceof Error) {
    const error = entity;
    return <InfoItem>{formatNotFoundError({ error })}</InfoItem>;
  }

  return <InfoItem>{entity.title}</InfoItem>;
};

RelatedRiskMitigation.Item = Item;

export default RelatedRiskMitigation;
